import Vue from 'vue'
import store from './store.js'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
	mode: 'history',
	linkExactActiveClass: 'active',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '',
			redirect: { name: 'dashboard' }
		},
		{
			path: '/login',
			name: 'login',
			component: () => import(/* webpackChunkName: "login" */ './views/Login.vue')
		},
		{
			path: '/preview',
			name: 'preview',
			component: () => import(/* webpackChunkName: "preview" */ './views/Preview.vue')
		},
		{
			path: '/dashboard',
			name: 'dashboard',
			component: () => import(/* webpackChunkName: "dashboard" */ './views/Dashboard.vue')
		},
		{
			path: '/pages',
			component: () => import(/* webpackChunkName: "pages" */ './views/Pages.vue'),
			children: [
				{
					path: '',
					component: () => import(/* webpackChunkName: "pages-overview" */ './views/pages/PagesOverview.vue')
				},
				{
					path: ':entityid/add',
					redirect: ':entityid/add/content',
					component: () => import(/* webpackChunkName: "add-page" */ './views/pages/AddPage.vue'),
					children: [
						{
							path: 'content',
							component: () => import(/* webpackChunkName: "add-page-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							component: () => import(/* webpackChunkName: "add-page-metadata" */ './views/pages/PageMetadata.vue')
						},
						{
							path: 'options',
							component: () => import(/* webpackChunkName: "add-page-options" */ './views/pages/PageOptions.vue')
						}
					]
				},
				{
					path: ':entityid/edit/:id',
					redirect: ':entityid/edit/:id/content',
					component: () => import(/* webpackChunkName: "edit-item" */ './views/content/EditObjectItem.vue'),
					children: [
						{
							path: 'content',
							component: () => import(/* webpackChunkName: "add-page-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							component: () => import(/* webpackChunkName: "add-page-metadata" */ './views/pages/PageMetadata.vue')
						},
						{
							path: 'options',
							component: () => import(/* webpackChunkName: "add-page-options" */ './views/pages/PageOptions.vue')
						}
					]
				}
			]
		},
		{
			path: '/pages/edit/:id',
			redirect: '/pages/edit/:id/fields',
			component: () => import(/* webpackChunkName: "edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'pages edit object fields',
					component: () => import(/* webpackChunkName: "edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'pages edit object options',
					component: () => import(/* webpackChunkName: "edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'pages edit object forms',
					component: () => import(/* webpackChunkName: "edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'pages edit object export',
					component: () => import(/* webpackChunkName: "edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/content',
			component: () => import(/* webpackChunkName: "content" */ './views/Content.vue'),
			children: [
				{
					path: '',
					name: 'content dashboard',
					component: () => import(/* webpackChunkName: "content-dashboard" */ './views/content/Dashboard.vue')
				},
				{
					path: ':entityid',
					name: 'content overview',
					component: () => import(/* webpackChunkName: "content-overview" */ './views/content/ObjectOverview.vue')
				},
				{
					path: ':entityid/edit/:id',
					redirect: ':entityid/edit/:id/content',
					component: () => import(/* webpackChunkName: "edit-item" */ './views/content/EditObjectItem.vue'),
					children: [
						{
							path: 'content',
							name: 'edit item content',
							component: () => import(/* webpackChunkName: "edit-item-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'edit item metadata',
							component: () => import(/* webpackChunkName: "edit-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				},
				{
					path: ':entityid/add',
					component: () => import(/* webpackChunkName: "add-item" */ './views/content/AddObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'add item content',
							component: () => import(/* webpackChunkName: "add-item-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'item metadata',
							component: () => import(/* webpackChunkName: "add-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				}
			]
		},
		{
			path: '/content/add/object',
			name: 'add object',
			component: () => import(/* webpackChunkName: "general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/content/edit/:id',
			redirect: '/content/edit/:id/fields',
			component: () => import(/* webpackChunkName: "edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'edit object fields',
					component: () => import(/* webpackChunkName: "edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'edit object options',
					component: () => import(/* webpackChunkName: "edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'edit object forms',
					component: () => import(/* webpackChunkName: "edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'edit object export',
					component: () => import(/* webpackChunkName: "edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/submissions',
			component: () => import(/* webpackChunkName: "submissions" */ './views/Submissions.vue'),
			children: [
				{
					path: '',
					name: 'submissions dashboard',
					component: () => import(/* webpackChunkName: "submissions-dashboard" */ './views/content/Dashboard.vue')
				},
				{
					path: ':entityid',
					name: 'submissions overview',
					component: () => import(/* webpackChunkName: "submissions-overview" */ './views/content/ObjectOverview.vue')
				}
			]
		},
		{
			path: '/submissions/add/object',
			name: 'submissions add object',
			component: () => import(/* webpackChunkName: "submissions-general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/submissions/edit/:id',
			redirect: '/submissions/edit/:id/fields',
			component: () => import(/* webpackChunkName: "submissions-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'submissions edit object fields',
					component: () => import(/* webpackChunkName: "submissions-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'submissions edit object options',
					component: () => import(/* webpackChunkName: "submissions-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'submissions edit object forms',
					component: () => import(/* webpackChunkName: "submissions-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'submissions edit object export',
					component: () => import(/* webpackChunkName: "submissions-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/trees',
			component: () => import(/* webpackChunkName: "trees" */ './views/Trees.vue'),
			children: [
				{
					path: '',
					name: 'trees dashboard',
					component: () => import(/* webpackChunkName: "trees-dashboard" */ './views/content/Dashboard.vue')
				},
				{
					path: ':entityid',
					name: 'trees overview',
					component: () => import(/* webpackChunkName: "trees-overview" */ './views/content/ObjectOverview.vue')
				},
				{
					path: ':entityid/edit/:id',
					component: () => import(/* webpackChunkName: "trees-edit-item" */ './views/content/EditObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'trees edit item trees',
							component: () => import(/* webpackChunkName: "edit-item-trees" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'trees edit item metadata',
							component: () => import(/* webpackChunkName: "trees-edit-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				},
				{
					path: ':entityid/add',
					component: () => import(/* webpackChunkName: "trees-add-item" */ './views/content/AddObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'trees add item trees',
							component: () => import(/* webpackChunkName: "add-item-trees" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'trees item metadata',
							component: () => import(/* webpackChunkName: "trees-add-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				}
			]
		},
		{
			path: '/trees/add/object',
			name: 'trees add object',
			component: () => import(/* webpackChunkName: "trees-general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/trees/edit/:id',
			redirect: '/trees/edit/:id/fields',
			component: () => import(/* webpackChunkName: "trees-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'trees edit object fields',
					component: () => import(/* webpackChunkName: "trees-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'trees edit object options',
					component: () => import(/* webpackChunkName: "trees-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'trees edit object forms',
					component: () => import(/* webpackChunkName: "trees-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'trees edit object export',
					component: () => import(/* webpackChunkName: "trees-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/references',
			component: () => import(/* webpackChunkName: "references" */ './views/References.vue'),
			children: [
				{
					path: '',
					name: 'references dashboard',
					component: () => import(/* webpackChunkName: "references-dashboard" */ './views/content/Dashboard.vue')
				},
				{
					path: ':entityid',
					name: 'references overview',
					component: () => import(/* webpackChunkName: "references-overview" */ './views/content/ObjectOverview.vue')
				},
				{
					path: ':entityid/edit/:id',
					component: () => import(/* webpackChunkName: "references-edit-item" */ './views/content/EditObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'references edit item references',
							component: () => import(/* webpackChunkName: "edit-item-references" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'references edit item metadata',
							component: () => import(/* webpackChunkName: "references-edit-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				},
				{
					path: ':entityid/add',
					component: () => import(/* webpackChunkName: "references-add-item" */ './views/content/AddObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'references add item references',
							component: () => import(/* webpackChunkName: "add-item-references" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'references item metadata',
							component: () => import(/* webpackChunkName: "references-add-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				}
			]
		},
		{
			path: '/references/add/object',
			name: 'references add object',
			component: () => import(/* webpackChunkName: "references-general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/references/edit/:id',
			redirect: '/references/edit/:id/fields',
			component: () => import(/* webpackChunkName: "references-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'references edit object fields',
					component: () => import(/* webpackChunkName: "references-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'references edit object options',
					component: () => import(/* webpackChunkName: "references-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'references edit object forms',
					component: () => import(/* webpackChunkName: "references-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'references edit object export',
					component: () => import(/* webpackChunkName: "references-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/seo',
			redirect: '/seo/metadata',
			component: () => import(/* webpackChunkName: "seo" */ './views/SEO.vue'),
			children: [
				{
					path: 'metadata',
					name: 'metadata',
					component: () => import(/* webpackChunkName: "metadata" */ './views/seo/Metadata.vue')
				},
				{
					path: 'headers',
					name: 'headers',
					component: () => import(/* webpackChunkName: "headers" */ './views/seo/Headers.vue')
				},
				{
					path: 'ga-code',
					name: 'GA code',
					component: () => import(/* webpackChunkName: "ga" */ './views/seo/Ga.vue')
				}
			]
		},
		{
			path: '/showpad',
			component: () => import(/* webpackChunkName: "showpad" */ './views/Showpad.vue'),
			children: [
				{
					path: '',
					name: 'experience',
					component: () => import(/* webpackChunkName: "experience" */ './views/showpad/Experience.vue')
				},
				{
					path: 'config',
					name: 'config',
					component: () => import(/* webpackChunkName: "config" */ './views/showpad/Config.vue')
				},
				{
					path: 'tags',
					name: 'tags',
					component: () => import(/* webpackChunkName: "tags" */ './views/showpad/Tags.vue')
				},
				{
					path: 'stores',
					name: 'stores',
					component: () => import(/* webpackChunkName: "stores" */ './views/showpad/Stores.vue')
				}
			]
		},
		{
			path: '/settings',
			component: () => import(/* webpackChunkName: "settings" */ './views/Settings.vue'),
			children: [
				{
					path: '',
					redirect: 'dashboard',
					component: () => import(/* webpackChunkName: "general-settings" */ './views/settings/General.vue'),
					children: [
						{
							path: 'dashboard',
							name: 'settings dashboard',
							component: () => import(/* webpackChunkName: "settings-dashboard" */ './views/settings/SettingsDashboard.vue')
						},
						{
							path: 'translations',
							name: 'translations',
							component: () => import(/* webpackChunkName: "translations" */ './views/settings/Translations.vue')
						},
						{
							path: 'languages',
							name: 'languages',
							component: () => import(/* webpackChunkName: "languages" */ './views/settings/Languages.vue')
						},
						{
							path: 'languages/add',
							name: 'add language',
							component: () => import(/* webpackChunkName: "add-language" */ './views/settings/AddLanguage.vue')
						},
						{
							path: 'mails',
							name: 'mails',
							component: () => import(/* webpackChunkName: "mails" */ './views/settings/Mails.vue')
						},
						{
							path: 'import',
							name: 'import',
							component: () => import(/* webpackChunkName: "import" */ './views/settings/Import.vue')
						},
						{
							path: 'views',
							name: 'views',
							component: () => import(/* webpackChunkName: "views" */ './views/settings/Views.vue')
						},
						{
							path: 'site-settings',
							name: 'site settings',
							component: () => import(/* webpackChunkName: "site-settings" */ './views/settings/SiteSettings.vue')
						},
						{
							path: 'caching',
							name: 'caching',
							component: () => import(/* webpackChunkName: "caching" */ './views/settings/Caching.vue')
						},
						{
							path: 'logs',
							name: 'logs',
							component: () => import(/* webpackChunkName: "logs" */ './views/settings/Logs.vue')
						}
					]
				},
				{
					path: ':entityid',
					name: 'settings overview',
					component: () => import(/* webpackChunkName: "settings-overview" */ './views/content/ObjectOverview.vue')
				},
				{
					path: ':entityid/edit/:id',
					component: () => import(/* webpackChunkName: "settings-edit-item" */ './views/content/EditObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'settings edit item content',
							component: () => import(/* webpackChunkName: "settings-edit-item-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'settings edit item metadata',
							component: () => import(/* webpackChunkName: "settings-edit-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				},
				{
					path: ':entityid/add',
					component: () => import(/* webpackChunkName: "settings-add-item" */ './views/content/AddObjectItem.vue'),
					children: [
						{
							path: '',
							name: 'settings add item content',
							component: () => import(/* webpackChunkName: "settings-add-item-content" */ './views/content/ItemContent.vue')
						},
						{
							path: 'metadata',
							name: 'settings item metadata',
							component: () => import(/* webpackChunkName: "settings-add-item-metadata" */ './views/content/Metadata.vue')
						}
					]
				}
			]
		},
		{
			path: '/settings/add/object',
			name: 'settings add object',
			component: () => import(/* webpackChunkName: "settings-general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/settings/edit/:id',
			redirect: '/settings/edit/:id/fields',
			component: () => import(/* webpackChunkName: "settings-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'settings edit object fields',
					component: () => import(/* webpackChunkName: "settings-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'settings edit object options',
					component: () => import(/* webpackChunkName: "settings-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'settings edit object forms',
					component: () => import(/* webpackChunkName: "settings-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'settings edit object export',
					component: () => import(/* webpackChunkName: "settings-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/users',
			component: () => import(/* webpackChunkName: "users" */ './views/Users.vue'),
			redirect: '/users/overview',
			children: [
				{
					path: 'overview',
					name: 'users overview',
					component: () => import(/* webpackChunkName: "users-overview" */ './views/users/Overview.vue')
				},
				{
					path: 'permissions',
					name: 'permissions',
					component: () => import(/* webpackChunkName: "users-permissions" */ './views/users/Permissions.vue')
				}
			]
		},
		{
			path: '/users/roles',
			component: () => import(/* webpackChunkName: "roles" */ './views/Roles.vue'),
			children: [
				{
					path: '',
					name: 'roles overview',
					component: () => import(/* webpackChunkName: "roles-overview" */ './views/users/Overview.vue')
				}
			]
		},
		{
			path: '/users/:entityid/add',
			component: () => import(/* webpackChunkName: "users-add-item" */ './views/content/AddObjectItem.vue'),
			children: [
				{
					path: '',
					name: 'users add item users',
					component: () => import(/* webpackChunkName: "add-item-users" */ './views/content/ItemContent.vue')
				},
				{
					path: 'metadata',
					name: 'users item metadata',
					component: () => import(/* webpackChunkName: "users-add-item-metadata" */ './views/content/Metadata.vue')
				}
			]
		},
		{
			path: '/roles/:entityid/add',
			component: () => import(/* webpackChunkName: "roles-add-item" */ './views/content/AddObjectItem.vue'),
			children: [
				{
					path: '',
					name: 'roles add item roles',
					component: () => import(/* webpackChunkName: "add-item-roles" */ './views/content/ItemContent.vue')
				},
				{
					path: 'metadata',
					name: 'roles item metadata',
					component: () => import(/* webpackChunkName: "roles-add-item-metadata" */ './views/content/Metadata.vue')
				}
			]
		},
		{
			path: '/users/:entityid/edit/:id',
			component: () => import(/* webpackChunkName: "users-edit-item" */ './views/content/EditObjectItem.vue'),
			children: [
				{
					path: '',
					name: 'users edit item users',
					component: () => import(/* webpackChunkName: "edit-item-users" */ './views/content/ItemContent.vue')
				},
				{
					path: 'metadata',
					name: 'users edit item metadata',
					component: () => import(/* webpackChunkName: "users-edit-item-metadata" */ './views/content/Metadata.vue')
				}
			]
		},
		{
			path: '/roles/:entityid/edit/:id',
			component: () => import(/* webpackChunkName: "roles-edit-item" */ './views/content/EditObjectItem.vue'),
			children: [
				{
					path: '',
					name: 'roles edit item roles',
					component: () => import(/* webpackChunkName: "edit-item-roles" */ './views/content/ItemContent.vue')
				},
				{
					path: 'metadata',
					name: 'roles edit item metadata',
					component: () => import(/* webpackChunkName: "roles-edit-item-metadata" */ './views/content/Metadata.vue')
				}
			]
		},
		{
			path: '/users/add/object',
			name: 'users add object',
			component: () => import(/* webpackChunkName: "users-general-add-object" */ './views/content/GeneralObject.vue')
		},
		{
			path: '/users/edit/:id',
			redirect: '/users/edit/:id/fields',
			component: () => import(/* webpackChunkName: "users-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'users edit object fields',
					component: () => import(/* webpackChunkName: "users-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'users edit object options',
					component: () => import(/* webpackChunkName: "users-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'users edit object forms',
					component: () => import(/* webpackChunkName: "users-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'users edit object export',
					component: () => import(/* webpackChunkName: "users-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/roles/edit/:id',
			redirect: '/roles/edit/:id/fields',
			component: () => import(/* webpackChunkName: "roles-edit-object" */ './views/content/EditObject.vue'),
			children: [
				{
					path: 'fields',
					name: 'roles edit object fields',
					component: () => import(/* webpackChunkName: "roles-edit-object-fields" */ './views/content/Fields.vue')
				},
				{
					path: 'options',
					name: 'roles edit object options',
					component: () => import(/* webpackChunkName: "roles-edit-object-options" */ './views/content/Options.vue')
				},
				{
					path: 'forms',
					name: 'roles edit object forms',
					component: () => import(/* webpackChunkName: "roles-edit-object-forms" */ './views/content/Forms.vue')
				},
				{
					path: 'export',
					name: 'roles edit object export',
					component: () => import(/* webpackChunkName: "roles-edit-object-export" */ './views/content/Export.vue')
				}
			]
		},
		{
			path: '/hosting',
			component: () => import(/* webpackChunkName: "hosting" */ './views/Hosting.vue'),
			children: [
				{
					path: '',
					name: 'cms-sites',
					component: () => import(/* webpackChunkName: "cms-sites" */ './views/hosting/Sites.vue')
				},
				{
					path: 'vhosts',
					name: 'vhosts',
					component: () => import(/* webpackChunkName: "vhosts" */ './views/hosting/Vhosts.vue')
				}
			]
		},
		{
			path: '/docs',
			component: () => import(/* webpackChunkName: "docs" */ './views/Docs.vue'),
			children: [
				{
					path: '',
					name: 'snippets',
					component: () => import(/* webpackChunkName: "snippets" */ './views/docs/Snippets.vue')
				},
				{
					path: 'code-usage',
					name: 'code usage',
					component: () => import(/* webpackChunkName: "code-usage" */ './views/docs/CodeUsage.vue')
				}
			]
		},
		{
			path: '*',
			redirect: { name: 'dashboard' }
		}
	]
})

// reload the page when we encounter a chunck or token error
// these errors can occur when the user tries to load previous version of the front end
// when we force the reload they will get the latest version
router.onError(error => {
	if (/loading chunk \d* failed./i.test(error.message) || /Unexpected token '<'/i.test(error.message)) {
		window.location.reload()
	}
})

router.beforeEach((to, from, next) => {
	// send users that are logged out back to the login page
	if (to.name !== 'login') {
		if (!store.getters.authStatus) {
			next('/login')
			return
		}
	} else if (to.name === 'login') {
		if (store.getters.authStatus) {
			next('/dashboard')
		} else {
			next()
		}
		return
	}

	// prevent users from going to an url when they don't have the privileges
	var allowed = checkRoutePrivileges(to, next)

	// do a check to see if we are trying to access a route with sub routes and if so check if we have access to the main route to redirect to a valid sub route we can access (e.g.: settings/translations)
	var redirectToSubRoute = checkForValidSubRoute(to)

	// allow admin all access
	if (store.getters.roles['Admin']) allowed = true

	if (!allowed) {
		if (redirectToSubRoute) {
			next('/' + redirectToSubRoute)
		} else {
			next('/dashboard')
		}
	} else {
		next()
	}
})

const checkRoutePrivileges = (to, next) => {
	if (!store.getters.privileges) return true
	var allowed = true
	var path = to.path
	var pagePrivileges = store.getters.privileges.pages

	// strip off the first slash
	while (path.charAt(0) === '/') {
		path = path.substr(1)
	}

	// check if path matches with route in privileges
	var match = false
	for (var route in pagePrivileges) {
		match = path.startsWith(route)
		if (match) {
			var privilege = pagePrivileges[route]
			if (!privilege) allowed = false

			// check if there is a directly matching route
			var directlyMatchingRoute = pagePrivileges[path]
			if (directlyMatchingRoute === 0) allowed = false
			if (directlyMatchingRoute === 1) allowed = true
			break
		}
	}

	return allowed
}

const checkForValidSubRoute = (to) => {
	var subroute = false
	var path = to.path
	var pagePrivileges = store.getters.privileges.pages
	var mainRoute = path.split('/')[1]

	if (pagePrivileges[mainRoute]) {
		// we seem to have access to the main route so now we need to check for a valid sub route
		for (var route in pagePrivileges) {
			var match = route.startsWith(mainRoute)
			if (match && pagePrivileges[route]) {
				// we can redirect to this route
				subroute = route
			}
		}
	}

	return subroute
}

export default router
